export const trackUmamiEvent = (event: string, data?: object) => {
  // Skip в development если аналитика отключена
  const isAnalyticsEnabled =
    import.meta.env.PROD ||
    import.meta.env.VITE_ENABLE_ANALYTICS === 'true';

  if (!isAnalyticsEnabled) {
    return;
  }

  try {
    if (window.umami && typeof window.umami.track === 'function') {
      window.umami.track(event, data);
    }
  } catch (error) {
    console.error(error);
  }
};
